<template>    
<div class="card border-0 mt-xl-5">
  <div class="card-body">

    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6 mb-2">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">First Name<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="text" class="form-control" placeholder="First Name" aria-describedby="emailHelp" v-model="f_name">
            </div>
          </div>
          <div class="col-6 mb-2">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Last Name<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="text" class="form-control" placeholder="Last Name" aria-describedby="emailHelp" v-model="l_name">
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Primary Email<i class="fa fa-asterisk text-danger ml-2" aria-hidden="true"></i></label>
              <input type="email" class="form-control" placeholder="Email Address" aria-describedby="emailHelp" v-model="pri_email">
            </div>
          </div>
          <div class="col-12 mb-4">
            <div class="form-group">
              <label for="exampleInputEmail1" class="small mb-0">Primary Phone</label>
              <VuePhoneNumberInput v-model="pri_phone"
                default-country-code="US"
                no-country-selector
                no-validator-state
              />
            </div>
            <div class="col-12 text-right">
              <small><em><i class="fa fa-asterisk text-danger" aria-hidden="true"></i> = Required</span></em></small>
            </div>
          </div>

          <div class="col-12">
            <button @click="cancelCreate" class="btn btn-danger">Cancel</button>
            <button @click="saveContact" class="btn btn-success">Save</button>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>
</template>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'  
import {store} from '../../../stores/settings-user-main-store.js'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';


export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      contactDetails: [],
      loadingContact: 0,
      f_name: '',
      l_name: '',
      pri_email: '',
      pri_phone: null,
    }
  },
  computed: {

  },
  watch: {

    
  },
  mounted() {

  },
  methods: {
    
    cancelCreate() {
      var _this = this;
      _this.$emit('onSecondary', [ 'contact-create' ])
    },
    saveContact() {
      var _this = this;
      _this.$toastr.warning('Validating contact information.', 'Please wait!')
      //validate with js
      var valErrors = [];
      //validate first name
      if(_this.f_name == '' || _this.f_name == null) { valErrors.push("A first name is required!") }
      //validate last name
      if(_this.l_name == '' || _this.l_name == null) { valErrors.push("A last name is required!") }
      if(_this.l_name.length <= 2 ) { valErrors.push("A last name requires more than two letters!") }
      //validate email
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(_this.pri_email == '' || _this.pri_email == null) { 
        valErrors.push("The primary email address is required!") 
      } else if (!_this.pri_email.match(mailformat)) {
        valErrors.push("The primary email address you entered is not valid!") 
      }
      var phoneFormat = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
      if(_this.pri_phone != '' && _this.pri_phone != null) {
        if(!_this.pri_phone.match(phoneFormat)) { valErrors.push("The primary phone number you entered is invalid!") }  
      }

      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 

      _this.$toastr.remove()

      _this.$toastr.warning('Saving new contact information.', 'Please wait!')
      axios.post('/utility/all/contact/storecontact', {
        f_name: _this.f_name,
        l_name: _this.l_name,
        pri_email: _this.pri_email,
        pri_phone: _this.pri_phone,
      })
        .then(function (response) {
          var msg = response.data.msg;
          var a = response.data.con;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', [ 'contact-create' ])
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })

    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },   
  },    
  components:{
    ScalingSquaresSpinner,
    VuePhoneNumberInput,
  },
  filters: {

  }
}
</script>
